export const currencyFormat = (value, { fixed = 2 } = {}) =>
  new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "PLN",
    minimumFractionDigits: fixed,
  }).format(value);
